import {
  Box,
  Grid,
  CardContent,
  CardMedia,
  Typography,
  useMediaQuery,
  useTheme,
  Link,
  Divider,
  Button,
  Breadcrumbs,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Loader from "./common/Loader";
import {
  setAmenities,
  setFilterNextAndPrev,
  setSearchResultsSlice,
} from "../store/searchSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "../store/store";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link as RouterLink } from "react-router-dom";
import { normalizeDateToUTC } from "../utils/dateUtils";
import countryJson from "../utils/countries.json";
import { formatCount } from "../utils/formatCount";

const BoatsAvailability = (props: any) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { loader } = props;
  const searchData = useSelector((state: RootState) => state.search);
  // State to hold search results, loading state, and pagination
  const [searchResults, setSearchResults] = useState<
    { dateFrom: string; dateTo: string }[]
  >(searchData?.searchResults?.results);
  const [yacht] = useState<any[]>(location.state?.tree);
  const [locationIndex, setLocationIndex] = useState<number>(
    location.state?.index,
  );
  useEffect(() => {
    setSearchResults(searchData?.searchResults?.results);
  }, [searchData?.searchResults?.results]);
  useEffect(() => {
    setLocationIndex(location.state?.index);
  }, [location.state?.index]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1); // Current page
  const [totalPages, setTotalPages] = useState<number>(1);

  const { t } = useTranslation() as any;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleYachtClick = (yacht: any) => {
    // Store the selected yacht details in localStorage

    // localStorage.setItem("selectedYacht", JSON.stringify(yacht));

    // Navigate to the yacht details page
    // navigate(`/yacht-details`, { state: { from: "yachtsLists" } });

    const dateFromUTC = normalizeDateToUTC(new Date(yacht?.dateFrom));
    const dateToUTC = normalizeDateToUTC(new Date(yacht?.dateTo));
    const matchedCountry = countryJson.find(
      (c) => c.name.toLowerCase() === yacht?.location?.country?.toLowerCase(),
    );
    const countryName = matchedCountry
      ? matchedCountry.code
      : yacht?.location?.country;

    const city = yacht?.startBase
      ? yacht?.startBase.trim().split(/\s+/)[0]
      : "";

    // navigate(
    //   `/yacht-details?country=${countryName}&city=${city}&yachtId=${yacht?.yachtId}&date_from=${encodeURIComponent(dateFromUTC)}&date_to=${encodeURIComponent(dateToUTC)}`
    // );
    window.open(
      `/yacht-details?country=${countryName}&city=${city}&yachtId=${yacht?.yachtId}&date_from=${encodeURIComponent(dateFromUTC)}&date_to=${encodeURIComponent(dateToUTC)}`,
      "_blank",
    );
  };

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 668,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    setTotalPages(Math.ceil(searchData?.searchResults?.count / 20));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (searchData?.searchResults?.count) {
      setTotalPages(Math.ceil(searchData?.searchResults?.count / 20));
    }
  }, [searchData?.searchResults]);

  const handleSearchNext = async ({
    api,
    page,
  }: {
    api: string;
    page: number;
  }) => {
    setLoading(true);
    try {
      const yachtResults = await axios.get(api);
      if (!yachtResults) {
        setSearchResults([]);
        setTotalPages(0);
        return;
      }

      setSearchResults(yachtResults.data.results);
      setTotalPages(Math.ceil(yachtResults.data.count / 20));
      const amenities: { label: string }[] = [];
      const seen = new Set<string>();

      if (yachtResults.data && Array.isArray(yachtResults.data.results)) {
        for (const item of yachtResults.data.results) {
          if (item.yacht?.equipment_json) {
            for (const equipment of item.yacht.equipment_json) {
              if (equipment.name && !seen.has(equipment.name)) {
                seen.add(equipment.name);
                amenities.push({ label: equipment.name });
              }
            }
          }
        }
      }

      dispatch(setSearchResultsSlice(yachtResults.data));
      dispatch(
        setFilterNextAndPrev({
          filterNext: yachtResults?.data.next || "",
          filterPrev: yachtResults?.data.previous || "",
        }),
      );
      dispatch(setAmenities(amenities));
      setTotalPages(Math.ceil(yachtResults?.data.count / 20));
      setPage(page);
    } catch (error) {
      console.error("Search failed", error);
    } finally {
      setLoading(false); // Always stop loading spinner
    }
  };

  return (
    <>
      {loader || loading ? (
        <div
          className="w-full"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          <Loader />
        </div>
      ) : (
        <Box
          sx={{
            padding: isSmallScreen ? "3rem 2rem" : "4rem 8rem",
          }}
        >
          <Breadcrumbs
            aria-label="breadcrumb"
            sx={{
              "@media (max-width: 600px)": {
                display: "none", // Hide on phone screens
              },
              "@media (max-width: 1200px)": {
                padding: "1rem", // Add padding for small screens
              },
            }}
            separator={
              <span style={{ color: "gray", fontSize: "14px" }}> &gt; </span>
            }
          >
            <RouterLink
              to="/"
              style={{
                textDecoration: "none",
                color: "#969090",
                fontWeight: "500",
              }}
            >
              Home
            </RouterLink>

            {yacht.length > 0 &&
              yacht.slice(0, locationIndex).map((item, index) => (
                <RouterLink
                  to={`/yacht-details/${item}`}
                  state={{
                    location: item.trim(),
                    tree: yacht,
                    index: index,
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#969090",
                    fontWeight: "500",
                  }}
                >
                  {item.replace(/\//g, "  >  ")}
                </RouterLink>
              ))}
          </Breadcrumbs>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", marginBottom: "1rem" }}
          >
            {searchData?.selectedLocation?.city &&
              searchData?.selectedLocation?.city + ","}{" "}
            {searchData?.selectedLocation?.countryName &&
              searchData?.selectedLocation?.countryName + ":"}{" "}
            {!searchData?.searchResults?.count
              ? "0"
              : formatCount(searchData?.searchResults?.count)}{" "}
            {t("available_text")}
          </Typography>
          <Divider sx={{ marginBottom: "4px" }} />
          <Typography
            variant="subtitle1"
            sx={{ marginBottom: "2rem", gap: "6px", display: "flex" }}
          >
            <Link
              component="button"
              variant="inherit"
              underline="none"
              sx={{
                color: "red",
                cursor: "pointer",
                "&:hover": {
                  color: "#1976d2",
                  textDecoration: "underline",
                },
              }}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              Select your check-in date
            </Link>
            to see updated prices and availability
          </Typography>

          {loader || loading ? (
            <div
              className="w-full"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Loader />
            </div>
          ) : isSmallScreen ? (
            <Slider {...sliderSettings}>
              {searchResults.length > 0 &&
                searchResults?.map((yacht: any, index: number) => (
                  <Box sx={{ maxWidth: "97%", mx: 1.5 }}>
                    <CardMedia
                      component="img"
                      height="150"
                      image={yacht?.yacht?.images[0]?.url}
                      alt="Dufour Yachts Dufour 512 Gl"
                      sx={{ borderRadius: 2, cursor: "pointer" }}
                      onClick={() => handleYachtClick(yacht)}
                    />
                    <CardContent sx={{ px: "0px" }}>
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ fontSize: "16px", cursor: "pointer" }}
                        onClick={() => handleYachtClick(yacht)}
                      >
                        {yacht?.yacht?.model}{" "}
                        {yacht?.yacht?.cabins_note &&
                          `- ${yacht?.yacht?.cabins_note} Cab`}{" "}
                        - {yacht?.yacht?.home_base_name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {yacht?.yacht?.cabins} cabins | {yacht?.yacht?.berths}
                        beds | Economy year (&lt;{yacht?.yacht?.year})
                        <br />
                        from {yacht?.actualPrice}€
                      </Typography>
                    </CardContent>
                  </Box>
                ))}
            </Slider>
          ) : (
            <Grid container spacing={2}>
              {searchResults?.length > 0 &&
                searchResults?.map((yacht: any, index: any) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    key={index}
                    // onClick={() => handleCardClick(yacht)}
                    sx={{ cursor: "pointer" }}
                  >
                    <Box sx={{ maxWidth: 345 }}>
                      <CardMedia
                        component="img"
                        height="150"
                        image={yacht?.yacht?.images[0]?.url}
                        alt="Dufour Yachts Dufour 512 Gl"
                        sx={{ borderRadius: 2, cursor: "pointer" }}
                        onClick={() => handleYachtClick(yacht)}
                      />
                      <CardContent>
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          sx={{ cursor: "pointer" }}
                          onClick={() => handleYachtClick(yacht)}
                        >
                          {yacht?.yacht?.model}{" "}
                          {yacht?.yacht?.cabins_note &&
                            `- ${yacht?.yacht?.cabins_note} Cab`}{" "}
                          - {yacht?.yacht?.home_base_name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {yacht?.yacht?.cabins} cabins | {yacht?.yacht?.berths}
                          beds | Economy year (&lt;{yacht?.yacht?.year})
                          <br />
                          from {yacht.actualPrice}€
                        </Typography>
                      </CardContent>
                    </Box>
                  </Grid>
                ))}
            </Grid>
          )}
          {searchResults?.length > 0 && !loader && !loading && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              {/* Previous Button */}
              <Button
                variant="contained"
                onClick={() => {
                  handleSearchNext({
                    api: searchData.searchResults.previous,
                    page: page - 1,
                  });
                }}
                disabled={page <= 1} // Disable if on the first page
                sx={{ mr: 2 }}
              >
                Prev
              </Button>

              <Typography sx={{ pt: 1 }}>
                Page {page} of {totalPages}
              </Typography>

              {/* Next Button */}
              <Button
                variant="contained"
                onClick={() => {
                  handleSearchNext({
                    api: searchData.searchResults.next,
                    page: page + 1,
                  });
                }}
                disabled={page >= totalPages} // Disable if on the last page
                sx={{ ml: 2 }}
              >
                Next
              </Button>
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

export default BoatsAvailability;
